

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://e20fb1fd0dbe463fb1e5b145f08e1b7a@sentry-next.wixpress.com/20202", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/7c2ba04858947e18/packages/loyalty-tpa/src/components/LoyaltyStatus/Widget/index.tsx';
    import createController from '/home/builduser/work/7c2ba04858947e18/packages/loyalty-tpa/src/components/LoyaltyStatus/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'LoyaltyStatus';
    var projectName = 'loyalty-tpa';
    var sentryConfig = {
      DSN: 'https://e20fb1fd0dbe463fb1e5b145f08e1b7a@sentry-next.wixpress.com/20202',
      id: 'undefined',
      projectName: 'loyalty-tpa',
      teamName: 'loyalty',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/7c2ba04858947e18/packages/loyalty-tpa/src/components/LoyaltyStatus/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["loyalty-tpa"]};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/7c2ba04858947e18/packages/loyalty-tpa/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"status-widget.settings.tabs.main":"Main","status-widget.settings.tabs.design":"Design","status-widget.settings.tabs.text":"Text","status-widget.settings.tabs.display":"Display","status-widget.settings.tabs.layout":"Layout","status-widget.settings.main-tab.title":"Customize the Loyalty widget","status-widget.settings.main-tab.subtitle":"Change the widget’s design and content to suit your loyalty program.","status-widget.settings.main-tab.customize-button":"Customize","status-widget.settings.main-tab.learn-more-button":"Learn More","status-widget.settings.design-tab.background-color-and-opacity":"Background color and opacity","status-widget.settings.design-tab.text-font-color":"Font and color","status-widget.settings.design-tab.text-color":"Text color and opacity","status-widget.settings.design-tab.border-color-and-opacity":"Border color and opacity","status-widget.settings.design-tab.corner-radius":"Corner radius","status-widget.settings.design-tab.border-width":"Border width","status-widget.settings.design-tab.choose-your-font":"Choose your font","status-widget.settings.design-tab.regular-tab":"Regular","status-widget.settings.design-tab.hover-tab":"Hover","status-widget.settings.layout-tab.select-layout.label":"Widget elements","status-widget.settings.layout-tab.select-layout.icon-and-text":"Both","status-widget.settings.layout-tab.select-layout.text-only":"Text","status-widget.settings.layout-tab.select-layout.icon-only":"Icon","status-widget.settings.layout-tab.select-icon-position.label":"Icon position","status-widget.settings.layout-tab.select-spacing.label":"Spacing between icon and text","status-widget.settings.layout-tab.icon-size.label":"Icon size","status-widget.settings.layout-tab.select-alignment.label":"Alignment","status-widget.settings.text-tab.before-login-tab":"Logged out","status-widget.settings.text-tab.after-login-tab":"Logged in","status-widget.settings.text-tab.points-balance.label":"Points label","status-widget.settings.text-tab.points-balance.tooltip":"The label will be shown together with the number of points a customer has (e.g., Points: 200).","status-widget.settings.text-tab.rewards-available.label":"Rewards label","status-widget.settings.text-tab.rewards-available.tooltip":"The label will be shown together with the number of rewards available to a customer (e.g., Rewards: 2).","status-widget.settings.text-tab.program-name.label":"Loyalty program name","status-widget.settings.text-tab.link.label":"Widget links to","status-widget.settings.text-tab.before-login.text-label":"Widget text","status-widget.settings.reset-button":"Reset to original design","status-widget.settings.bp.banner.desktop-and-tablet":"Changes apply to desktop and tablet.","status-widget.settings.bp.banner.cascades":"Changes will cascade to lower breakpoints.","status-widget.settings.bp.banner.all":"Changes apply to all breakpoints.","status-widget.settings.bp.banner.mobile":"Changes apply to mobile only.","status-widget.settings.bp.learn-more":"Learn more","status-widget.settings.bp.learn-more.link":"https://support.wix.com/en/article/working-with-breakpoints","status-widget.settings.display-tab.choices.title":"Choose widget content","status-widget.settings.display-tab.choices.points-balance":"Customer’s points balance","status-widget.settings.display-tab.choices.rewards-tooltip":"The number of available rewards includes redeemed coupons and any rewards a customer has enough points for.","status-widget.settings.display-tab.choices.rewards":"Available rewards","status-widget.settings.display-tab.choices.program-name":"Loyalty program name","status-widget.settings.display-tab.edit-program-explanation":"To change the loyalty program name and icon, go to your <1>dashboard</1>.","status-widget.points-balance.default-text":"Points","status-widget.rewards-available.default-text":"Rewards","status-widget.program-name.default-text":"Loyalty program","status-widget.before-login.default-text":"View points","status-widget.program-icon.alt-text":"Loyalty program icon","status-widget.add-panel.description":"Pin the widget to all pages for customers to see it as they browse, keep it in the header, or place it on a specific page. You can customize the widget after adding it. <l>Learn more</l>","status-widget.add-panel.description.link":"https://support.wix.com/en/article/wix-loyalty-program-adding-a-loyalty-widget-to-your-sites-header","status-widget.add-panel.button.add":"Add Widget","status-widget.add-panel.button.cancel":"Cancel"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "553c79f3-5625-4f38-b14b-ef7c0d1e87df";
    var componentId = "f30e2cf0-de22-453e-ac3b-973c84cd4311";
    var localeDistPath = 'components/LoyaltyStatus/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/7c2ba04858947e18/packages/loyalty-tpa/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
